module.exports = __webpack_public_path__ + "img/icon-location.198a5437.svg";